import React, { Component } from 'react';
import '../App.css';
import { Stage, Layer, Circle, Image, Group} from 'react-konva';
import SavedCurve from '../Curves/SavedCurve';
import SavedLines from '../Curves/SavedLines';
import CentreLine from '../Curves/CenterLine';
const EXIF = require('exif-js')
let pointkey = 1;
let curvekey = 1;
let imageData = [];


class Point extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      color: 'yellow',
      radius: 1.5,
      x: props.x,
      y: props.y,
    };
  } 

  render() {
    return (
      <Circle
      x = {this.props.x}
      y = {this.props.y}
      radius = {(this.state.radius/this.props.scale)*1.2}
      fill = {this.state.color}
      stroke = {'black'}
      strokeWidth = {0.5}
      />
    );
  }
}


 

class SailImage extends React.Component {
  constructor(props) {
    super(props);

    this.myRef = React.createRef();
    this.myImage = React.createRef();
    this.curvesLayer = React.createRef();
    this.pointsLayer = React.createRef();

    this.state = {
      username: 'Shano',
      col2width: 300,
      col2height: 300,
      divWidth: 300,
      divHeight: 300,
      stageX: 0,
      stageY: 0,
      ratio: 1,
      updated: false,
      curves: [],
      lines: [],
      selectedCurve: null,
      selectedLine: null,
      points: [],
      Xmin: 0,
      Ymin: 0,
      pointer: 'default',
      imageInfo: null,
      image: props.image,
      newImage: true,
      width: 300,
      height: 300,
      pointNo: 0,
      imageInfo: [],
      name: '',
      scaleX: 1,
      isCentreline: false,
      centreline: null,
      centrelineTwist: 0,
      newCurve: false,
      oldWidth : 0,
      oldHeight: 0,
      scale:1,
    }

  }

  getWidth(){
    return this.img.width();
  }

  getHeight(){
    return this.img.height();
  }

  getRatio(){
    return this.state.ratio;
  }

  getInfo(){
    let info = this.state.imageInfo;
    return info;
  }


  openSail = (img, data) =>{
    //this.newImage(img);
    this.openImage(img, data, (img, data) =>{

        if(data.sailType == 0){
          this.props.app.setState({ sail: data.sail, sailType:0});
        }else if(data.sailType == 1){
          this.props.app.setState({ sail: data.sail, sailType:1});
        }else{
          this.props.app.setState({ sail: data.sail, sailType:2});
        }
    
        this.props.app.setState({
          curves: data.curves, 
          selectedCurve:null, 
          imageSRC:img, 
          LogData:data.LogData, 
          imageTime: data.imageTime, 
          comments:data.comments,
          lines: data.lines,
          centreline: data.centreline,
          centrelineTwist: data.centrelineTwist,
        });
          
        //this.props.app.loginforef.setState({data:data.LogData});  ////////////////////////////////////
        
      }      
    );
  }

  openImage = (img, data, callback) => {

    const image = new window.Image();
    image.src = img;

    image.onload = () => {

      const w = image.width;
      const h = image.height;

      const imageAspect = h/w;
      const divAspect = this.myRef.current.offsetHeight / this.myRef.current.offsetWidth;
      
      let height = 0;
      let width = 0;

      //if(divAspect <= imageAspect){
      //   height = this.myRef.current.offsetHeight;
      //   width =  this.myRef.current.offsetHeight / imageAspect;
      //}else{
        height = this.myRef.current.offsetWidth * imageAspect;
        width =  this.myRef.current.offsetWidth;    
      //}

      let scale = width/data.imageSize.width;
      console.log("image w ", data.imageSize.width, " current w ", width, " scale ", scale)

      this.getSavedImageExif(image, img, data);

      this.setState({
        image: image,
        ratio: imageAspect,
        width: w,
        height: h,
        name: img.replace(/^.*[\\\/]/, ''),
        col2width: width, 
        col2height: height, 
        divWidth: this.myRef.current.offsetWidth,
        divHeight: this.myRef.current.offsetHeight,
        curves: data.curves,
        lines: data.lines,
        centreline: data.centreline,
        centrelineTwist: data.centrelineTwist,
        selectedCurve: null,
        points: [],
        pointer: 'default',
        imageInfo: null,
        scale: scale,
      });
    };

    window.addEventListener('resize', this.resize);

    callback(img, data);
  }

  getSavedImageExif = (img, name, imageData) =>{
    const self = this;
      EXIF.getData(img, function() {
        //var model = EXIF.getTag(this, "Model");
        let allMetaData = EXIF.getAllTags(this);
        let data = {
          Name: name.replace(/^.*[\\\/]/, ''),
          DateTimeOriginal: imageData.imageTime,
          PixelXDimension: allMetaData.PixelXDimension,
          PixelYDimension: allMetaData.PixelYDimension,
        }
        self.setState({imageInfo: data}); 
        self.props.app.setState({imageInfo: data, imageTime:imageData.imageTime});
        self.props.app.imageDataRef.setState({loading:true});
        self.props.app.imageDataRef.updateInfo(data); 
      });
    }

  updatePoints = (p) => {
    this.setState({
      points: p,
    })
  }

  updateCurves = (c) => {
    this.setState({
      selectedCurve: c,
      points: [],
      pointer:"move",
    })
  }



 wheelHandler = (e) =>{
    e.evt.preventDefault();
    const scaleBy = 1.05;
    let oldScale = this.stage.scaleX();

    let mousePointTo = {
      x: this.stage.getPointerPosition().x / oldScale - this.stage.x() / oldScale,
      y: this.stage.getPointerPosition().y / oldScale - this.stage.y() / oldScale
    };

    let newScale = e.evt.deltaY > 0 ? oldScale * scaleBy : oldScale / scaleBy;
    if(newScale > 1){
      this.stage.scale({ x: newScale, y: newScale});
    }else{
      this.stage.scale({ x: 1, y: 1});
    }


    let xc = this.stage.x();
    let yc = this.stage.y();
    let Xmin = this.getWidth() - (this.getWidth() * this.stage.scaleX());
    let Ymin = this.getHeight() - (this.getHeight() * this.stage.scaleX());

    let newPos = {
        x:
          -(mousePointTo.x - this.stage.getPointerPosition().x / newScale) *
          newScale,
        y:
          -(mousePointTo.y - this.stage.getPointerPosition().y / newScale) *
          newScale
      };  

    let x = this.findXmin(newPos);
    let y = this.findYmin(newPos);

    this.setState({stageX: x, stageY:y, Xmin:Xmin, Ymin:Ymin});
    
 }




 ////////////////////////////////////////////////////////////////////////////////////////////////

 resize = () => {

  if(this.myRef.current){

  const imageAspect = this.state.ratio;
  const divAspect = this.myRef.current.offsetHeight / this.myRef.current.offsetWidth;

  let height = 0;
  let width = 0;

      //if(divAspect <= imageAspect){
      //   height = this.myRef.current.offsetHeight;
      //   width =  this.myRef.current.offsetHeight / imageAspect;
      //}else{
        height = this.myRef.current.offsetWidth * imageAspect;
        width =  this.myRef.current.offsetWidth;    
      //}


  this.setState({col2width: width, 
                  col2height: height, 
                  divWidth: this.myRef.current.offsetWidth, 
                  divHeight: this.myRef.current.offsetHeight,
                });
  }

  }

 componentDidMount(){

 }

 componentDidUpdate(){

  }

 curveMouseOver = (event) => {
  this.setState({pointer:"pointer"});
}

curveMouseLeave = (event) => {
  this.setState({pointer:"default"});
}

 findXmin = (pos) =>{
  if(pos.x > this.state.Xmin && pos.x < 0){
    return pos.x;
  }
  else if(pos.x > 0){
    return 0;
  }
  else{
    return this.state.Xmin;
  }
 }

 findYmin = (pos) =>{
  if(pos.y > this.state.Ymin && pos.y < 0){
    return pos.y;
  }
  else if(pos.y > 0){
    return 0;
  }
  else{
    return this.state.Ymin;
  }
 }


  render() {

    const rwMax = {
      margin: '0px 0px 0px 0px',
    }

    let stageStyle = {
      cursor: this.state.pointer,
    }

    let image = null;
    let stage = null;
    let shapes = null;

    shapes = (
      <Layer
        scale={{x:this.state.scale, y:this.state.scale}}
        ref={node => {this.shapes = node;}}
      >
      {<CentreLine parent={this} curve={this.state.centreline}  mouseOver={this.curveMouseOver} mouseLeave={this.curveMouseLeave} editHandler={this.editCentreLine}/>}    
      {<SavedCurve parent={this} data={this.state.curves}  mouseOver={this.curveMouseOver} mouseLeave={this.curveMouseLeave} editHandler={this.editCurve}/>}   
      {<SavedLines parent={this} data={this.state.lines}  mouseOver={this.curveMouseOver} mouseLeave={this.curveMouseLeave} editHandler={this.editLine}/>}         
      </Layer>
    );
    
    image = (
        <Image 
        image={this.state.image} 
        scaleX={this.state.scaleX}
        x={this.state.x}
        width={this.state.col2width} 
        height={this.state.col2height}
        onclick={this.state.click}
        ref={node => {this.img = node;}}
        />
    );

    stage=(
      <Stage 
        x={this.state.stageX} 
        y={this.state.stageY} 
        ref={node => {this.stage = node;}} 
        width={this.state.col2width} 
        height={this.state.col2height} 
        style={ stageStyle }
        draggable={true} 
        onContentWheel={this.wheelHandler}
        dragBoundFunc ={(pos) => {
            let newY = this.findYmin(pos);
            let newX = this.findXmin(pos);
            return {
              x: newX,
              y: newY
            }}}>
      <Layer>
        {image}
      </Layer>
      {shapes}
    </Stage>   
    );



    return (

        <div ref={this.myRef} style={{height:"100%"}}>
          {stage}
        </div>

    );
  }
}

export default SailImage;